const post = (win, type, payload) => {
	try {
		win.postMessage({
			action_type: type,
			type: 'nearpodMessage',
			payload,
		}, '*')
	} catch (e) {
	}
}

const postMessage = (type, payload = {}, scope = 'self') => {
	post(window[scope], type, payload)
}

const iterateFrames = (win, type, payload) => {
	try {
		const frames = win.frames
		Array.prototype.forEach.call(frames, frame => {
			post(frame, type, payload)
			iterateFrames(frame, type, payload)
		})
	} catch (err) {

	}
}

const postInFrames = (type, payload = {}, scope = 'parent') => {
	iterateFrames(window[scope], type, payload)
}

export default postMessage

export {
	postInFrames,
}
